import { S3CLOUD_CLOUDFRONT_ASSET } from '../../config/s3directories'

const cat = 'floral'

const thumbnailurl = (n) => `${S3CLOUD_CLOUDFRONT_ASSET}${cat}/${n}/thumbnail`
const lookupurl = (n) => `${S3CLOUD_CLOUDFRONT_ASSET}${cat}/${n}/lookup`
const bannerurl = (n) => `${S3CLOUD_CLOUDFRONT_ASSET}${cat}/${n}/banner`
const seatchart = (n) => `${S3CLOUD_CLOUDFRONT_ASSET}${cat}/${n}/seatchart`

export const allimages = new Map([
    [ // Empty
        'Empty',
        {
            name: `Empty`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: { // seatchart
                topleft: {
                    url: ['']
                },
                topright: {
                    url: ['']
                },
            },
            banner: { // t1 and t2
                url: ``
                // url: ['', '']
            },
            't1': {
                background: {
                    topleft: {
                        url: ['', '']
                    },
                    topright: {
                        url: ['', '']
                    },
                    btmright: {
                        url: ['', '']
                    },
                    btmleft: {
                        url: ['', '']
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: ['', '']
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: ['', '']
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [
                            { state: true, img1: 0, img2: 0 },
                            { state: true, img1: 0, img2: 1 },
                            { state: true, img1: 1, img2: 0 },
                            { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: true, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ],
            },
            't2': {
                bgtop: '',
                bgbtm: '',
            }
        }
    ],
    [ // Amaryllis_Purpurea
        'Amaryllis_Purpurea',
        {
            name: `Amaryllis Purpurea
(Barbados lily)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Amaryllis Purpurea, also known as Barbados lily or Amaryllis, is a bold and elegant flower that is often used in wedding decorations. In the language of flowers, Amaryllis represents pride and determination, symbolizing the couple's commitment and confidence in their relationship. Its large, showy blooms make it a perfect addition to centerpieces, bouquets, and other floral arrangements. Amaryllis is available in different colors, including red, pink, white, and peach, and can be used in weddings throughout the year. Its versatility and beauty make it an ideal choice for creating stunning wedding decor.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Amaryllis_Purpurea')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Amaryllis_Purpurea')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Amaryllis_Purpurea')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Amaryllis_Purpurea')}/topleft0.png`, `${lookupurl('Amaryllis_Purpurea')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Amaryllis_Purpurea')}/topright0.png`, `${lookupurl('Amaryllis_Purpurea')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Amaryllis_Purpurea')}/btmright0.png`, `${lookupurl('Amaryllis_Purpurea')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Amaryllis_Purpurea')}/btmleft0.png`, `${lookupurl('Amaryllis_Purpurea')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Amaryllis_Purpurea')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Amaryllis_Purpurea')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [
                            { state: true, img1: 0, img2: 0 },
                            { state: false, img1: 0, img2: 1 },
                            { state: false, img1: 1, img2: 0 },
                            { state: false, img1: 1, img2: 1 }
                        ],
                        orientation_allow_listmobile: [
                            { state: true, img1: 0, img2: 0 },
                            { state: false, img1: 0, img2: 1 },
                            { state: false, img1: 1, img2: 0 },
                            { state: false, img1: 1, img2: 1 }
                        ],
                        WEB_TABLET: { state: false, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }
        }
    ],
    [ // Blanket_Flower
        `Blanket_Flower`,
        {
            name: `Blanket flower
(Gaillardia)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Blanket flower, also known as Gaillardia, is a vibrant and colorful flower that can add a cheerful touch to any wedding decor. Its common name is derived from its resemblance to the bright patterns found in Native American blankets. In the language of flowers, Blanket flower represents undying love and devotion, making it a fitting choice for a wedding. Blanket flower blooms in a range of colors, including red, yellow, and orange, and can be used in bridal bouquets, centerpieces, and other floral arrangements. Its bold and cheerful blooms are sure to bring joy and happiness to any wedding celebration.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Blanket_Flower')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Blanket_Flower')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Blanket_Flower')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Blanket_Flower')}/topleft0.png`, `${lookupurl('Blanket_Flower')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Blanket_Flower')}/topright0.png`, `${lookupurl('Blanket_Flower')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Blanket_Flower')}/btmright0.png`, `${lookupurl('Blanket_Flower')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Blanket_Flower')}/btmleft0.png`, `${lookupurl('Blanket_Flower')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Blanket_Flower')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Blanket_Flower')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }
        }
    ],
    [ // Crimson_Damask
        'Crimson_Damask',
        {
            name: `Crimson Damask
(The Hay Rose Garden)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Roseraie de l'Hay, also known as The Hay Rose Garden, is a beautiful hybrid rugosa rose that is often used in wedding decorations. This rose variety features stunning double blooms in shades of deep pink, mauve, and purple, and is known for its hardiness and disease resistance. In the language of flowers, roses represent love, passion, and devotion, making Roseraie de l'Hay a perfect choice for a wedding. This rose can be used in bridal bouquets, centerpieces, and other floral arrangements, adding a romantic and timeless touch to the wedding decor. Its stunning blooms and sweet fragrance are sure to create a beautiful ambiance for the special day.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Crimson_Damask')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Crimson_Damask')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Crimson_Damask')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Crimson_Damask')}/topleft0.png`, `${lookupurl('Crimson_Damask')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Crimson_Damask')}/topright0.png`, `${lookupurl('Crimson_Damask')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Crimson_Damask')}/btmright0.png`, `${lookupurl('Crimson_Damask')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Crimson_Damask')}/btmleft0.png`, `${lookupurl('Crimson_Damask')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Crimson_Damask')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Crimson_Damask')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: true, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }

        }
    ],
    [ // Helenium
        'Helenium',
        {
            name: `Helenium
(Purple Sneezeweed)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Helenium atropurpureum, also known as Purple Sneezeweed, is a beautiful and unique flower that can add a pop of color to wedding decorations. This flower features vibrant purple petals with a dark center, making it a striking addition to bridal bouquets and centerpieces. In the language of flowers, Helenium represents strength and endurance, symbolizing the couple's commitment to their love and marriage. While not as well-known as some other wedding flowers, Helenium atropurpureum can make a beautiful and unexpected addition to wedding decor, adding a touch of uniqueness and personality to the special day.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Helenium')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Helenium')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Helenium')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Helenium')}/topleft0.png`, `${lookupurl('Helenium')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Helenium')}/topright0.png`, `${lookupurl('Helenium')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Helenium')}/btmright0.png`, `${lookupurl('Helenium')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Helenium')}/btmleft0.png`, `${lookupurl('Helenium')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Helenium')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Helenium')}/thumbnail.png`
                },

                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: true, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }


        }
    ],
    [ // Leptodactylon_Californicum
        'Leptodactylon_Californicum',
        {
            name: `Leptodactylon Californicum
(Prairie flax)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Leptodactylon_Californicum')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Leptodactylon_Californicum')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Leptodactylon_Californicum')}/banner.png`
            },
            't1': {
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Leptodactylon_Californicum')}/thumbnail.png`
                },
                background: {
                    topleft: {
                        url: [`${lookupurl('Leptodactylon_Californicum')}/topleft0.png`, `${lookupurl('Leptodactylon_Californicum')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Leptodactylon_Californicum')}/topright0.png`, `${lookupurl('Leptodactylon_Californicum')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Leptodactylon_Californicum')}/btmright0.png`, `${lookupurl('Leptodactylon_Californicum')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Leptodactylon_Californicum')}/btmleft0.png`, `${lookupurl('Leptodactylon_Californicum')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Leptodactylon_Californicum')}/btm.png`]
                    },
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }
        }
    ],
    [ // Mexican_Poppy
        'Mexican_Poppy',
        {
            name: `Mexican Poppy
(California Poppy)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Eschscholzia mexicana, also known as Mexican gold poppy or California poppy, is a beautiful flower that is native to western North America. This flower is known for its vibrant yellow-orange blooms and delicate, feathery foliage. In the language of flowers, Eschscholzia represents wealth and success, making it a fitting choice for a wedding. While not as commonly used in weddings as some other flowers, Mexican gold poppy can make a unique and beautiful addition to bridal bouquets and other floral arrangements. Its bright and cheerful blooms are sure to bring joy and happiness to any special occasion.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Mexican_Poppy')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Mexican_Poppy')}/seatchart.png`]
                },
            },

            banner: {
                url: `${bannerurl('Mexican_Poppy')}/banner.png`
            },
            't1': {
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Mexican_Poppy')}/thumbnail.png`
                },
                background: {
                    topleft: {
                        url: [`${lookupurl('Mexican_Poppy')}/topleft0.png`, `${lookupurl('Mexican_Poppy')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Mexican_Poppy')}/topright0.png`, `${lookupurl('Mexican_Poppy')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Mexican_Poppy')}/btmright0.png`, `${lookupurl('Mexican_Poppy')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Mexican_Poppy')}/btmleft0.png`, `${lookupurl('Mexican_Poppy')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Mexican_Poppy')}/btm.png`]
                    },
                },

                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {}
        }
    ],
    [ // Myosotis_Alpestris
        'Myosotis_Alpestris',
        {
            name: `Myosotis Alpestris
(Alpine Forget-me-not)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Myosotis alpestris, also known as Alpine Forget-me-not, is a delicate and charming flower that is native to the mountains of Europe. This flower features small, sky-blue blooms with yellow centers and soft, fuzzy foliage. In the language of flowers, Forget-me-nots represent true love and memories, making it a meaningful choice for a wedding. While not as commonly used in weddings as some other flowers, Alpine Forget-me-not can make a lovely addition to bridal bouquets and other floral arrangements. Its dainty blooms and delicate appearance symbolize the fragility and beauty of love, and serve as a sweet reminder of the couple's special day.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Myosotis_Alpestris')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Myosotis_Alpestris')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Myosotis_Alpestris')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Myosotis_Alpestris')}/topleft0.png`, `${lookupurl('Myosotis_Alpestris')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Myosotis_Alpestris')}/topright0.png`, `${lookupurl('Myosotis_Alpestris')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Myosotis_Alpestris')}/btmright0.png`, `${lookupurl('Myosotis_Alpestris')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Myosotis_Alpestris')}/btmleft0.png`, `${lookupurl('Myosotis_Alpestris')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Myosotis_Alpestris')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Myosotis_Alpestris')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }


        }
    ],
    [ // Red_Epidendrum
        'Red_Epidendrum',
        {
            name: `Red Epidendrum`,
            availablein: ['t1', 't2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Epidendrum Erubescens, also known as the Red Epidendrum, is a striking orchid that is native to Central and South America. This orchid features tall stems with bright red blooms that have a waxy texture and a slight fragrance. In the language of flowers, the Red Epidendrum represents strength and courage, making it a fitting choice for a wedding. While not as commonly used in weddings as some other flowers, the Red Epidendrum can make a unique and meaningful addition to bridal bouquets and other floral arrangements. Its bold and vibrant appearance symbolizes the passion and vitality of the couple's love, and serves as a beautiful reminder of their special day.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Red_Epidendrum')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Red_Epidendrum')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Red_Epidendrum')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Red_Epidendrum')}/topleft0.png`, `${lookupurl('Red_Epidendrum')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Red_Epidendrum')}/topright0.png`, `${lookupurl('Red_Epidendrum')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Red_Epidendrum')}/btmright0.png`, `${lookupurl('Red_Epidendrum')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Red_Epidendrum')}/btmleft0.png`, `${lookupurl('Red_Epidendrum')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Red_Epidendrum')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Red_Epidendrum')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {
                bgtop: `${lookupurl('Red_Epidendrum')}/top.png`,
                bgbtm: `${lookupurl('Red_Epidendrum')}/btm.png`,
            }
        }
    ],
    [ // Rosa_Gallica
        'Rosa_Gallica',
        {
            name: `Rosa Gallica
(Damask Rose)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Rosa Damascena Coccinea, also known as the Coccinea Damask Rose, is a beautiful and fragrant flower that is often used in perfumes and essential oils. This rose variety features clusters of deep red blooms with a sweet and spicy fragrance. In the language of flowers, the Coccinea Damask Rose represents love and passion, making it a popular choice for weddings. Its stunning appearance and intoxicating scent make it a classic and timeless addition to bridal bouquets and other floral arrangements. The Coccinea Damask Rose is also rich in cultural and historical significance, and has been cultivated for centuries in various parts of the world.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Rosa_Gallica')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rosa_Gallica')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rosa_Gallica')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Rosa_Gallica')}/topleft0.png`, `${lookupurl('Rosa_Gallica')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Rosa_Gallica')}/topright0.png`, `${lookupurl('Rosa_Gallica')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Rosa_Gallica')}/btmright0.png`, `${lookupurl('Rosa_Gallica')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Rosa_Gallica')}/btmleft0.png`, `${lookupurl('Rosa_Gallica')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Rosa_Gallica')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Rosa_Gallica')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: true, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ],
            },
            't2': {

            }
        }
    ],
    [ // Rosa_Sulfurea
        'Rosa_Sulfurea',
        {
            name: `Rosa Sulfurea
(Sulfur Yellow Rose)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Rosa Sulfurea, also known as the Sulfur Yellow Rose, is a unique and eye-catching rose variety that features stunning sulfur yellow blooms with a light fragrance. In the language of flowers, the Sulfur Yellow Rose represents happiness and joy, making it a wonderful choice for weddings. Its bright and cheerful appearance is symbolic of the happiness and excitement of the couple's special day, and it can make a lovely addition to bridal bouquets and other floral arrangements. The Sulfur Yellow Rose is a relatively rare rose variety, making it a special and distinctive choice for a wedding.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Rosa_Sulfurea')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rosa_Sulfurea')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rosa_Sulfurea')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Rosa_Sulfurea')}/topleft0.png`, `${lookupurl('Rosa_Sulfurea')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Rosa_Sulfurea')}/topright0.png`, `${lookupurl('Rosa_Sulfurea')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Rosa_Sulfurea')}/btmright0.png`, `${lookupurl('Rosa_Sulfurea')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Rosa_Sulfurea')}/btmleft0.png`, `${lookupurl('Rosa_Sulfurea')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Rosa_Sulfurea')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Rosa_Sulfurea')}/thumbnail.png`
                },

                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }

        }
    ],
    [ // Slender_Flowered_Gilia
        'Slender_Flowered_Gilia',
        {
            name: `Slender Flowered Gilia
(Gilia Flexuosa)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Slender-flowered Gilia, also known as Gilia Flexuosa, is a delicate and charming flower that is native to the western United States. This flower variety features slender stems that are adorned with clusters of tiny pink or lavender blooms. In the language of flowers, the Slender-flowered Gilia represents purity and innocence, making it a perfect choice for a wedding. Its dainty and delicate appearance is symbolic of the bride's beauty and grace, and it can make a lovely addition to bridal bouquets and other floral arrangements. The Slender-flowered Gilia is a subtle and understated choice, but its elegance and simplicity make it a timeless classic.`,
            corner: {
                topleft: {
                    url: [`${seatchart('Slender_Flowered_Gilia')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Slender_Flowered_Gilia')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Slender_Flowered_Gilia')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('Slender_Flowered_Gilia')}/topleft0.png`, `${lookupurl('Slender_Flowered_Gilia')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('Slender_Flowered_Gilia')}/topright0.png`, `${lookupurl('Slender_Flowered_Gilia')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('Slender_Flowered_Gilia')}/btmright0.png`, `${lookupurl('Slender_Flowered_Gilia')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('Slender_Flowered_Gilia')}/btmleft0.png`, `${lookupurl('Slender_Flowered_Gilia')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('Slender_Flowered_Gilia')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('Slender_Flowered_Gilia')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],

                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }

        }
    ],
    [ // White_Odontoglossum
        'White_Odontoglossum',
        {
            name: `Odontoglossum Roezlii
(White Butterfly Orchid)`,
            availablein: ['t1'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: `Odontoglossum Roezlii Album, commonly known as "white butterfly orchid," is a beautiful and elegant flower that symbolizes purity, innocence, and everlasting love in the context of weddings. The delicate and fragrant white blooms with intricate patterns resemble fluttering butterflies, making them a popular choice for bridal bouquets and floral arrangements. According to flower language, giving a white butterfly orchid conveys the message of pure and true love, making it a perfect choice for couples on their wedding day. The simplicity and elegance of these flowers make them a timeless addition to any wedding celebration.`,
            corner: {
                topleft: {
                    url: [`${seatchart('White_Odontoglossum')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('White_Odontoglossum')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('White_Odontoglossum')}/banner.png`
            },
            't1': {
                background: {
                    topleft: {
                        url: [`${lookupurl('White_Odontoglossum')}/topleft0.png`, `${lookupurl('White_Odontoglossum')}/topleft1.png`]
                    },
                    topright: {
                        url: [`${lookupurl('White_Odontoglossum')}/topright0.png`, `${lookupurl('White_Odontoglossum')}/topright1.png`]
                    },
                    btmright: {
                        url: [`${lookupurl('White_Odontoglossum')}/btmright0.png`, `${lookupurl('White_Odontoglossum')}/btmright1.png`]
                    },
                    btmleft: {
                        url: [`${lookupurl('White_Odontoglossum')}/btmleft0.png`, `${lookupurl('White_Odontoglossum')}/btmleft1.png`]
                    },
                    midleft: {
                        url: []
                    },
                    midright: {
                        url: []
                    },
                    top: {
                        url: []
                    },
                    btm: {
                        url: [`${lookupurl('White_Odontoglossum')}/btm.png`]
                    },
                },
                thumbnail: { // thumbnail use btmleft
                    url: `${thumbnailurl('White_Odontoglossum')}/thumbnail.png`
                },
                bgformat: [ // determine whatimage to be used
                    {
                        // 0 TOP_RIGHT_BTM_LEFT
                        // detemine the orientation of image, bg1 and bg2 is the address of the img for background
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topright', bg2: 'btmleft' },
                        MOBILE: { state: true, bg1: 'topright', bg2: 'btmleft' }
                    },
                    {
                        // 1 TOP_LEFT_BTM_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'btmright' },
                        MOBILE: { state: true, bg1: 'topleft', bg2: 'btmright' }
                    },
                    {
                        // 2 BTM_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 }],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: true, bg1: 'btmleft', bg2: 'btmright' },
                        MOBILE: { state: false, bg1: 'btmleft', bg2: 'btmright' }
                    },
                    {
                        // 3 TOP_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'topleft', bg2: 'topright' },
                        MOBILE: { state: false, bg1: 'topleft', bg2: 'topright' }
                    },
                    {
                        // 4 MID_LEFT_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: 'midright' },
                        MOBILE: { state: false, bg1: 'midleft', bg2: 'midright' }
                    },
                    {
                        // 5 MID_RIGHT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midright', bg2: null },
                        MOBILE: { state: false, bg1: 'midright', bg2: null }
                    },
                    {
                        // 6 MID_LEFT
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'midleft', bg2: null },
                        MOBILE: { state: false, bg1: 'midleft', bg2: null }
                    },
                    {
                        // 7 TOP_BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: 'btm' },
                        MOBILE: { state: false, bg1: 'top', bg2: 'btm' }
                    },
                    {
                        // 8 TOP
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }], orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'top', bg2: null },
                        MOBILE: { state: false, bg1: 'top', bg2: null }
                    },
                    {
                        // 9 BTM
                        orientation_allow_list: [{ state: true, img1: 0, img2: 0 }, { state: false, img1: 0, img2: 1 }, { state: false, img1: 1, img2: 0 }, { state: false, img1: 1, img2: 1 },],
                        orientation_allow_listmobile: [{ state: true, img1: 0, img2: 0 }, { state: true, img1: 0, img2: 1 }, { state: true, img1: 1, img2: 0 }, { state: true, img1: 1, img2: 1 }],
                        WEB_TABLET: { state: false, bg1: 'btm', bg2: null },
                        MOBILE: { state: false, bg1: 'btm', bg2: null, affectnamepos: { state: true }, }
                    }
                ]
            },
            't2': {

            }

        }
    ],
    [ // De_Candolle_Rose
        'De_Candolle_Rose',
        {
            name: `De Candolle Rose`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('De_Candolle_Rose')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('De_Candolle_Rose')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('De_Candolle_Rose')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('De_Candolle_Rose')}/top.png`,
                bgbtm: `${lookupurl('De_Candolle_Rose')}/btm.png`,
            }

        }
    ],
    [ // Bloom_Collection
        'Bloom_Collection',
        {
            name: `Bloom Collection`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Bloom_Collection')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Bloom_Collection')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Bloom_Collection')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Bloom_Collection')}/top.png`,
                bgbtm: `${lookupurl('Bloom_Collection')}/btm.png`,
            }

        }
    ],
    [ // Phlox_Amoena
        'Phlox_Amoena',
        {
            name: `Phlox Amoena`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Phlox_Amoena')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Phlox_Amoena')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Phlox_Amoena')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Phlox_Amoena')}/top.png`,
                bgbtm: `${lookupurl('Phlox_Amoena')}/btm.png`,
            }

        }
    ],
    [ // Azalea
        'Azalea',
        {
            name: `Azalea`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Azalea')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Azalea')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Azalea')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Azalea')}/top.png`,
                bgbtm: `${lookupurl('Azalea')}/btm.png`,
            }

        }
    ],
    [ // White_Paradise
        'White_Paradise',
        {
            name: `White Paradise`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('White_Paradise')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('White_Paradise')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('White_Paradise')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('White_Paradise')}/top.png`,
                bgbtm: `${lookupurl('White_Paradise')}/btm.png`,
            }

        }
    ],
    [ // Rosa_Candolleana_Elegans
        'Rosa_Candolleana_Elegans',
        {
            name: `Rosa Candolleana Elegans`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Rosa_Candolleana_Elegans')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rosa_Candolleana_Elegans')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rosa_Candolleana_Elegans')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Rosa_Candolleana_Elegans')}/top.png`,
                bgbtm: `${lookupurl('Rosa_Candolleana_Elegans')}/btm.png`,
            }

        }
    ],
    [ // Rosa_Indica_Caryophyllea
        'Rosa_Indica_Caryophyllea',
        {
            name: `Rosa Indica Caryophyllea`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Rosa_Indica_Caryophyllea')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rosa_Indica_Caryophyllea')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rosa_Indica_Caryophyllea')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Rosa_Indica_Caryophyllea')}/top.png`,
                bgbtm: `${lookupurl('Rosa_Indica_Caryophyllea')}/btm.png`,
            }

        }
    ],
    [ // Rosa_Multiflora_Carnea
        'Rosa_Multiflora_Carnea',
        {
            name: `Rosa Multiflora Carnea`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Rosa_Multiflora_Carnea')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rosa_Multiflora_Carnea')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rosa_Multiflora_Carnea')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Rosa_Multiflora_Carnea')}/top.png`,
                bgbtm: `${lookupurl('Rosa_Multiflora_Carnea')}/btm.png`,
            }

        }
    ],
    [ // Epidendrum_Polyanthum
        'Epidendrum_Polyanthum',
        {
            name: `Epidendrum Polyanthum`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Epidendrum_Polyanthum')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Epidendrum_Polyanthum')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Epidendrum_Polyanthum')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Epidendrum_Polyanthum')}/top.png`,
                bgbtm: `${lookupurl('Epidendrum_Polyanthum')}/btm.png`,
            }

        }
    ],
    [ // Plum_Blossoms
        'Plum_Blossoms',
        {
            name: `Plum Blossoms`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Plum_Blossoms')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Plum_Blossoms')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Plum_Blossoms')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used

                ]
            },
            't2': {
                bgtop: `${lookupurl('Plum_Blossoms')}/top.png`,
                bgbtm: `${lookupurl('Plum_Blossoms')}/btm.png`,
            }

        }
    ],
    [ // Rosa_Banksiae
        'Rosa_Banksiae',
        {
            name: `Rosa Banksiae`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Rosa_Banksiae')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rosa_Banksiae')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rosa_Banksiae')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Rosa_Banksiae')}/top.png`,
                bgbtm: `${lookupurl('Rosa_Banksiae')}/btm.png`,
            }
        }
    ],
    [ // Paperwhites
        'Paperwhites',
        {
            name: `Paperwhites`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Paperwhites')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Paperwhites')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Paperwhites')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Paperwhites')}/top.png`,
                bgbtm: `${lookupurl('Paperwhites')}/btm.png`,
            }
        }
    ],
    [ // White_Wild_Rose
        'White_Wild_Rose',
        {
            name: `White Wild Rose`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('White_Wild_Rose')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('White_Wild_Rose')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('White_Wild_Rose')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('White_Wild_Rose')}/top.png`,
                bgbtm: `${lookupurl('White_Wild_Rose')}/btm.png`,
            }
        }
    ],
    [ // Purple_Mallow
        'Purple_Mallow',
        {
            name: `Purple Mallow`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Purple_Mallow')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Purple_Mallow')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Purple_Mallow')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Purple_Mallow')}/top.png`,
                bgbtm: `${lookupurl('Purple_Mallow')}/btm.png`,
            }
        }
    ],
    [ // Chinese_Primula
        'Chinese_Primula',
        {
            name: `Chinese Primula`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Chinese_Primula')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Chinese_Primula')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Chinese_Primula')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Chinese_Primula')}/top.png`,
                bgbtm: `${lookupurl('Chinese_Primula')}/btm.png`,
            }
        }
    ],
    [ // Apple_Blossom
        'Apple_Blossom',
        {
            name: `Apple Blossom`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Apple_Blossom')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Apple_Blossom')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Apple_Blossom')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Apple_Blossom')}/top.png`,
                bgbtm: `${lookupurl('Apple_Blossom')}/btm.png`,
            }
        }
    ],
    [ // Forget_Not_Me
        'Forget_Not_Me',
        {
            name: `Forget Not Me`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Forget_Not_Me')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Forget_Not_Me')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Forget_Not_Me')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Forget_Not_Me')}/top.png`,
                bgbtm: `${lookupurl('Forget_Not_Me')}/btm.png`,
            }
        }
    ],
    [ // Bluets
        'Bluets',
        {
            name: `Bluets`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Bluets')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Bluets')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Bluets')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Bluets')}/top.png`,
                bgbtm: `${lookupurl('Bluets')}/btm.png`,
            }
        }
    ],
    [ // Jacob_Ladder
        'Jacob_Ladder',
        {
            name: `Jacob Ladder`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Jacob_Ladder')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Jacob_Ladder')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Jacob_Ladder')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Jacob_Ladder')}/top.png`,
                bgbtm: `${lookupurl('Jacob_Ladder')}/btm.png`,
            }
        }
    ],
    [ // Bearberry
        'Bearberry',
        {
            name: `Bearberry`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Bearberry')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Bearberry')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Bearberry')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Bearberry')}/top.png`,
                bgbtm: `${lookupurl('Bearberry')}/btm.png`,
            }
        }
    ],
    [ // Rose_Gentian
        'Rose_Gentian',
        {
            name: `Rose Gentian`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Rose_Gentian')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Rose_Gentian')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Rose_Gentian')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Rose_Gentian')}/top.png`,
                bgbtm: `${lookupurl('Rose_Gentian')}/btm.png`,
            }
        }
    ],
    [ // Lisianthus
        'Lisianthus',
        {
            name: `Lisianthus`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Lisianthus')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Lisianthus')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Lisianthus')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Lisianthus')}/top.png`,
                bgbtm: `${lookupurl('Lisianthus')}/btm.png`,
            }
        }
    ],
    [ // Fringed_Gentian
        'Fringed_Gentian',
        {
            name: `Fringed Gentian`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Fringed_Gentian')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Fringed_Gentian')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Fringed_Gentian')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Fringed_Gentian')}/top.png`,
                bgbtm: `${lookupurl('Fringed_Gentian')}/btm.png`,
            }
        }
    ],
    [ // Gilia_Arizonica
        'Gilia_Arizonica',
        {
            name: `Gilia Arizonica`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Gilia_Arizonica')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Gilia_Arizonica')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Gilia_Arizonica')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Gilia_Arizonica')}/top.png`,
                bgbtm: `${lookupurl('Gilia_Arizonica')}/btm.png`,
            }
        }
    ],
    [ // Marsh_Marigold
        'Marsh_Marigold',
        {
            name: `Marsh Marigold`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Marsh_Marigold')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Marsh_Marigold')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Marsh_Marigold')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Marsh_Marigold')}/top.png`,
                bgbtm: `${lookupurl('Marsh_Marigold')}/btm.png`,
            }
        }
    ],
    [ // Greenstem_Paperflower
        'Greenstem_Paperflower',
        {
            name: `Greenstem Paperflower`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Greenstem_Paperflower')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Greenstem_Paperflower')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Greenstem_Paperflower')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Greenstem_Paperflower')}/top.png`,
                bgbtm: `${lookupurl('Greenstem_Paperflower')}/btm.png`,
            }
        }
    ],
    [ // Purple_Monkey_Flower
        'Purple_Monkey_Flower',
        {
            name: `Purple Monkey Flower`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Purple_Monkey_Flower')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Purple_Monkey_Flower')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Purple_Monkey_Flower')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Purple_Monkey_Flower')}/top.png`,
                bgbtm: `${lookupurl('Purple_Monkey_Flower')}/btm.png`,
            }
        }
    ],
    [ // Scarlet_Globe_Mallow
        'Scarlet_Globe_Mallow',
        {
            name: `Scarlet Globe Mallow`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Scarlet_Globe_Mallow')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Scarlet_Globe_Mallow')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Scarlet_Globe_Mallow')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Scarlet_Globe_Mallow')}/top.png`,
                bgbtm: `${lookupurl('Scarlet_Globe_Mallow')}/btm.png`,
            }
        }
    ],
    [ // Thicket_Hawthorn
        'Thicket_Hawthorn',
        {
            name: `Thicket Hawthorn`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Thicket_Hawthorn')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Thicket_Hawthorn')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Thicket_Hawthorn')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Thicket_Hawthorn')}/top.png`,
                bgbtm: `${lookupurl('Thicket_Hawthorn')}/btm.png`,
            }
        }
    ],
    [ // Vervain
        'Vervain',
        {
            name: `Vervain`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Vervain')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Vervain')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Vervain')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Vervain')}/top.png`,
                bgbtm: `${lookupurl('Vervain')}/btm.png`,
            }
        }
    ],
    [ // Zinnia
        'Zinnia',
        {
            name: `Zinnia`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Zinnia')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Zinnia')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Zinnia')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Zinnia')}/top.png`,
                bgbtm: `${lookupurl('Zinnia')}/btm.png`,
            }
        }
    ],
    [ // Wild_Hyacinth
        'Wild_Hyacinth',
        {
            name: `Wild Hyacinth`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Wild_Hyacinth')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Wild_Hyacinth')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Wild_Hyacinth')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Wild_Hyacinth')}/top.png`,
                bgbtm: `${lookupurl('Wild_Hyacinth')}/btm.png`,
            }
        }
    ],
    [ // Wild_Sweet_Crab
        'Wild_Sweet_Crab',
        {
            name: `Wild Sweet Crab`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Wild_Sweet_Crab')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Wild_Sweet_Crab')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Wild_Sweet_Crab')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Wild_Sweet_Crab')}/top.png`,
                bgbtm: `${lookupurl('Wild_Sweet_Crab')}/btm.png`,
            }
        }
    ],
    [ // Flower_Luxe
        'Flower_Luxe',
        {
            name: `Flower Luxe`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Flower_Luxe')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Flower_Luxe')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Flower_Luxe')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Flower_Luxe')}/top.png`,
                bgbtm: `${lookupurl('Flower_Luxe')}/btm.png`,
            }
        }
    ],
    [ // Wildflower_Charm
        'Wildflower_Charm',
        {
            name: `Wildflower Charm`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Wildflower_Charm')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Wildflower_Charm')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Wildflower_Charm')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Wildflower_Charm')}/top.png`,
                bgbtm: `${lookupurl('Wildflower_Charm')}/btm.png`,
            }
        }
    ],
    [ // Viscaria_Vulgaris
        'Viscaria_Vulgaris',
        {
            name: `Viscaria Vulgaris`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Viscaria_Vulgaris')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Viscaria_Vulgaris')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Viscaria_Vulgaris')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Viscaria_Vulgaris')}/top.png`,
                bgbtm: `${lookupurl('Viscaria_Vulgaris')}/btm.png`,
            }
        },

    ],
    [ // Tuberose
        'Tuberose',
        {
            name: `Tuberose`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Tuberose')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Tuberose')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Tuberose')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Tuberose')}/top.png`,
                bgbtm: `${lookupurl('Tuberose')}/btm.png`,
            }
        }
    ],
    [ // Tetrandrous_Condollea
        'Tetrandrous_Condollea',
        {
            name: `Tetrandrous Condollea`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Tetrandrous_Condollea')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Tetrandrous_Condollea')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Tetrandrous_Condollea')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Tetrandrous_Condollea')}/top.png`,
                bgbtm: `${lookupurl('Tetrandrous_Condollea')}/btm.png`,
            }
        }
    ],
    [ // Almond_Blossom
        'Almond_Blossom',
        {
            name: `Almond Blossom`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Almond_Blossom')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Almond_Blossom')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Almond_Blossom')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Almond_Blossom')}/top.png`,
                bgbtm: `${lookupurl('Almond_Blossom')}/btm.png`,
            }
        }
    ],
    [ // Apple_Blossoms
        'Apple_Blossoms',
        {
            name: `Apple Blossoms`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Apple_Blossoms')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Apple_Blossoms')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Apple_Blossoms')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Apple_Blossoms')}/top.png`,
                bgbtm: `${lookupurl('Apple_Blossoms')}/btm.png`,
            }
        }
    ],
    [ // Apricot_Flower
        'Apricot_Flower',
        {
            name: `Apricot Flower`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Apricot_Flower')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Apricot_Flower')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Apricot_Flower')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Apricot_Flower')}/top.png`,
                bgbtm: `${lookupurl('Apricot_Flower')}/btm.png`,
            }
        }
    ],
    [ // Ruellia_Brittoniana
        'Ruellia_Brittoniana',
        {
            name: `Ruellia Brittoniana`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Ruellia_Brittoniana')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Ruellia_Brittoniana')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Ruellia_Brittoniana')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Ruellia_Brittoniana')}/top.png`,
                bgbtm: `${lookupurl('Ruellia_Brittoniana')}/btm.png`,
            }
        }
    ],
    [ // Sea Lavender 
        'Sea_Lavender',
        {
            name: `Sea Lavender`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Sea_Lavender')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Sea_Lavender')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Sea_Lavender')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Sea_Lavender')}/top.png`,
                bgbtm: `${lookupurl('Sea_Lavender')}/btm.png`,
            }
        }
    ],
    [ // Shewy Aster
        'Shewy_Aster',
        {
            name: `Shewy Aster`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Shewy_Aster')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Shewy_Aster')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Shewy_Aster')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Shewy_Aster')}/top.png`,
                bgbtm: `${lookupurl('Shewy_Aster')}/btm.png`,
            }
        }
    ],
    [ // Spartium_Junceum
        'Spartium_Junceum',
        {
            name: `Spartium Junceum`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Spartium_Junceum')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Spartium_Junceum')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Spartium_Junceum')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Spartium_Junceum')}/top.png`,
                bgbtm: `${lookupurl('Spartium_Junceum')}/btm.png`,
            }
        }
    ],
    [ // Aster
        'Aster',
        {
            name: `Aster`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Aster')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Aster')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Aster')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Aster')}/top.png`,
                bgbtm: `${lookupurl('Aster')}/btm.png`,
            }
        }
    ],
    [ // California_Poppy
        'California_Poppy',
        {
            name: `California Poppy`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('California_Poppy')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('California_Poppy')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('California_Poppy')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('California_Poppy')}/top.png`,
                bgbtm: `${lookupurl('California_Poppy')}/btm.png`,
            }
        }
    ],
    [ // Canchalagua
        'Canchalagua',
        {
            name: `Canchalagua`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Canchalagua')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Canchalagua')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Canchalagua')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Canchalagua')}/top.png`,
                bgbtm: `${lookupurl('Canchalagua')}/btm.png`,
            }
        }
    ],
    [ // Cliff_Rose
        'Cliff_Rose',
        {
            name: `Cliff Rose`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Cliff_Rose')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Cliff_Rose')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Cliff_Rose')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Cliff_Rose')}/top.png`,
                bgbtm: `${lookupurl('Cliff_Rose')}/btm.png`,
            }
        }
    ],
    [ // Fragrant_Devotion
        'Fragrant_Devotion',
        {
            name: `Fragrant Devotion`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Fragrant_Devotion')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Fragrant_Devotion')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Fragrant_Devotion')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Fragrant_Devotion')}/top.png`,
                bgbtm: `${lookupurl('Fragrant_Devotion')}/btm.png`,
            }
        }
    ],
    [ // Spring_Harmony
        'Spring_Harmony',
        {
            name: `Spring Harmony`,
            availablein: ['t2'],
            cat: 'Floral',
            itype: ['Wedding'],
            summary: ``,
            corner: {
                topleft: {
                    url: [`${seatchart('Spring_Harmony')}/seatchart.png`]
                },
                topright: {
                    url: [`${seatchart('Spring_Harmony')}/seatchart.png`]
                },
            },
            banner: {
                url: `${bannerurl('Spring_Harmony')}/banner.png`
            },
            't1': {
                background: {
                },
                thumbnail: { // thumbnail use btmleft
                },
                bgformat: [ // determine whatimage to be used
                ]
            },
            't2': {
                bgtop: `${lookupurl('Spring_Harmony')}/top.png`,
                bgbtm: `${lookupurl('Spring_Harmony')}/btm.png`,
            }
        }
    ],
    [ // Syringa
    'Syringa',
    {
        name: `Syringa`,
        availablein: ['t2'],
        cat: 'Floral',
        itype: ['Wedding'],
        summary: ``,
        corner: {
            topleft: {
                url: [`${seatchart('Syringa')}/seatchart.png`]
            },
            topright: {
                url: [`${seatchart('Syringa')}/seatchart.png`]
            },
        },
        banner: {
            url: `${bannerurl('Syringa')}/banner.png`
        },
        't1': {
            background: {
            },
            thumbnail: { // thumbnail use btmleft
            },
            bgformat: [ // determine whatimage to be used
            ]
        },
        't2': {
            bgtop: `${lookupurl('Syringa')}/top.png`,
            bgbtm: `${lookupurl('Syringa')}/btm.png`,
        }
    }
],
])

export const bannernames = []
allimages.forEach((obj) => {
    const { name } = obj
    bannernames.push(name)
    return
})

export const banners = []
allimages.forEach((obj) => {
    const { url } = obj.banner
    banners.push(url)
    return
})

export const flowers = [] // only in t1
allimages.forEach((obj) => {
    const { url } = obj['t1'].thumbnail
    flowers.push(url)
    return
})

export const corners = []
allimages.forEach((obj) => {
    const { url } = obj.corner.topleft
    corners.push(url)
    return
})

export const corners_banners_corners = []
allimages.forEach((obj) => {
    corners_banners_corners.push({
        name: obj.name,
        corner: obj.corner.topleft.url,
        banner: obj.banner.url
    })
    return
})